import { EA, REVIEWADMIN, REVIEWSCHEDULER } from "../../../utils/Constants";

export const createRSFS_CARDFilters = (set, get) => ({
    RSFSCardFilters: {
        selectedButton: 'AllBFiles',
        selectedAgency: undefined,
        selectedAgencyName: undefined,
        selectedFilterOption: 'AllBFiles',
        datemodified: {
            start_date: "2010-01-01",
            end_date: "2050-01-01"
        },
        selectedToggle: REVIEWSCHEDULER,
        selectedToggleAPI: undefined,
        showLeaderBoardGrid: false,
        selectedLeaderBoardAgency: undefined,
        selectedLeaderBoardUsers: [],
        selectedAdminToggle: REVIEWADMIN,
        selectedAdminToggleAPI: REVIEWADMIN,
        defaultToggleUserRole: undefined,
        dateRangeAdminFilter: 1,
        hideBadPhoneNumber: 1,
        selectedUserId: undefined
    },

    setRSFSCardFilters: (newFilter) =>
        set((state) => ({
            RSFSCardFilters: {
                ...state.RSFSCardFilters,
                ...newFilter,
                datemodified: {
                    ...state.RSFSCardFilters.datemodified,
                    ...newFilter.datemodified,
                }
            },
        })),

    resetRSFSCardFilters: () =>
        set(() => ({
            RSFSCardFilters: {
                selectedAgency: undefined,
                selectedAgencyName: undefined,
                selectedFilterOption: 'AllBFiles',
                datemodified: {
                    start_date: "2010-01-01",
                    end_date: "2050-01-01"
                },
                selectedToggle: REVIEWSCHEDULER,
                selectedToggleAPI: undefined,
                defaultToggleUserRole: undefined,
                selectedAdminToggle: REVIEWADMIN,
                selectedAdminToggleAPI: REVIEWADMIN,
                dateRangeAdminFilter: 1,
                hideBadPhoneNumber: 1,
                showLeaderBoardGrid: false,
                selectedLeaderBoardAgency: undefined,
                selectedLeaderBoardUsers: [],
                selectedUserId: undefined,
            }
        })),

});



// WEBPACK FOOTER //
// ./src/store/slices/FS/RSFS-cardSlice.js